const MILLISECONDS_IN_SECOND = 1000;
const MILLISECONDS_IN_MINUTE = 60 * MILLISECONDS_IN_SECOND;
const MILLISECONDS_IN_HOUR = 60 * MILLISECONDS_IN_MINUTE;
const MILLISECONDS_IN_DAY = 24 * MILLISECONDS_IN_HOUR;
const MILLISECONDS_IN_WEEK = 7 * MILLISECONDS_IN_DAY;
const MILLISECONDS_IN_MONTH = 30 * MILLISECONDS_IN_DAY;
const MILLISECONDS_IN_YEAR = 365 * MILLISECONDS_IN_DAY;
function formatValue(value) {
    return Number.isInteger(value) ? value.toString() : value.toFixed(1);
}
/**
 * Formats the time to a human readable format.
 * @param time - The time to format.
 * @returns The formatted time.
 * @example
 * formatTime(1000) // '1s'
 * formatTime(60000) // '1min'
 * formatTime(3600000) // '1h'
 * formatTime(86400000) // '1d'
 * formatTime(604800000) // '1w'
 * formatTime(2592000000) // '1M'
 * formatTime(31536000000) // '1y'
 */
export function formatTime(time) {
    if (!time || isNaN(time) || !Number.isFinite(time) || time < 0) {
        return '0 s';
    }
    if (time < MILLISECONDS_IN_SECOND) {
        return `${time} ms`;
    }
    if (time < MILLISECONDS_IN_MINUTE) {
        return `${formatValue(time / MILLISECONDS_IN_SECOND)} s`;
    }
    if (time < MILLISECONDS_IN_HOUR) {
        return `${formatValue(time / MILLISECONDS_IN_MINUTE)} min`;
    }
    if (time < MILLISECONDS_IN_DAY) {
        return `${formatValue(time / MILLISECONDS_IN_HOUR)} h`;
    }
    if (time < MILLISECONDS_IN_WEEK) {
        return `${formatValue(time / MILLISECONDS_IN_DAY)} d`;
    }
    if (time < MILLISECONDS_IN_MONTH) {
        return `${formatValue(time / MILLISECONDS_IN_WEEK)} w`;
    }
    if (time < MILLISECONDS_IN_YEAR) {
        return `${formatValue(time / MILLISECONDS_IN_MONTH)} M`;
    }
    return `${formatValue(time / MILLISECONDS_IN_YEAR)} y`;
}
